import React from 'react';
import { Description } from '../../Description';
import { Header } from '../../Header';
import styles from './MessageOverlay.scss';
export var MessageOverlay = function MessageOverlay(_ref) {
  var message = _ref.message,
      secondaryMessage = _ref.secondaryMessage,
      leftMargin = _ref.leftMargin,
      width = _ref.width;
  return React.createElement("div", {
    style: {
      marginLeft: leftMargin,
      width: width
    },
    "data-test": "chart-message-overlay",
    className: styles.flexy
  }, React.createElement("div", {
    className: styles.messageBox
  }, React.createElement(Header, {
    variant: "h5"
  }, message), React.createElement(Description, null, secondaryMessage)));
};
MessageOverlay.displayName = 'MessageOverlay';